export const ACTION_VALUES = {
  TRY_AGAIN: 'TRY_AGAIN',
};
